import { Route, Routes } from 'react-router-dom'
import { NotificationsPage } from 'pages/settings/pages/notifications/ui/NotificationsPage'

export const NotificationsRouter = () => {
  return (
    <Routes>
      <Route index element={<NotificationsPage />} />
    </Routes>
  )
}
